export default {
  title: "SORU8",
  text: `Bir projenin başarıya ulaşmasında birçok etken vardır. En başta proje kapsamında çalışacak her bir elemanın, yapacağı işle ilgili üst düzey bilgi birikimine sahip olması gerekir. Bu, çıkacak sorunların hızla çözülmesinde ve projenin sorunsuz ilerlemesinde önemli bir etkendir. Proje çalışanlarının birbiriyle uyumlu ve eş zamanlı çalışması da projenin sağlıklı yürümesi için çok önemlidir. Bunlarla birlikte maliyete ve takvime uygun bir çalışmanın yapılması da gerekir.`
};



// WEBPACK FOOTER //
// ./src/assets/goz-ritim/lgs/8.js